import { TFunction } from "i18next";

type ServingTypeTitleParams = {
    orderType?: ApiOrderType | null;
    tableId?: number | null;
    tableNumber?: string | null;
    tablesListData?: CashBoxTableOrOrderTypeItem[];
    t: TFunction,
};

export const getServingTypeTitle = ({
    orderType,
    tableId,
    tableNumber,
    tablesListData,
    t
}: ServingTypeTitleParams) => {
    let displayingTitle = "";

    if (tableNumber) {
        displayingTitle = `${t('table')} ${tableNumber}`;
    }
    else if (!tablesListData?.length && orderType && orderType !== "normal") {
        displayingTitle = orderType;
    }
    else {
        const selectedTableOrOrderTypeData = (tablesListData || []).find(it => (
            (tableId && it.id === tableId) || (orderType && it.key === orderType)
        ));
        if (selectedTableOrOrderTypeData?.title) {
            displayingTitle = !tableId
                ? selectedTableOrOrderTypeData?.title
                : `${t('table')} ${selectedTableOrOrderTypeData?.title}`;
        }
    }

    return displayingTitle;
};
